import React from 'react'
import PanelHeader from '../panel-header-candidate'
import CandidateTable from '../candidate-table'

const ListCandidateView = () => {
    return (
        <div>
            <PanelHeader />
            <CandidateTable />
        </div>
    )
}

export default ListCandidateView
